module.exports = __webpack_public_path__ + "images/emoji/tent.e75c512a3d6bd1c77600.png";